module.exports = __webpack_public_path__ + "img/timeline_en_animated.1bb9f6ab.svg";